import { SVGProps, Ref, forwardRef } from 'react';

export const SpeakerWaveFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9.135 4.714c2.2-1.465 3.3-2.197 4.083-1.364C14 4.183 14 6.087 14 9.895v4.21c0 3.808 0 5.712-.782 6.545-.783.833-1.883.1-4.083-1.364-1.396-.929-2.795-1.853-4.186-2.789q-.217.003-.449.003C.563 16.5 0 15.938 0 12s.563-4.5 4.5-4.5q.232 0 .449.003c1.39-.937 2.79-1.86 4.186-2.79M20.161 18.12l1.44 1.08A11.95 11.95 0 0 0 24 12.002v-.004c0-2.701-.893-5.193-2.4-7.198l-1.44 1.08A10.15 10.15 0 0 1 22.2 12c0 2.296-.759 4.416-2.04 6.12M20 12a7.97 7.97 0 0 1-1.6 4.8l-1.44-1.08A6.17 6.17 0 0 0 18.2 12a6.17 6.17 0 0 0-1.24-3.72L18.4 7.2C19.405 8.537 20 10.199 20 12"
                fill="currentColor"
            />
        </g>
    </svg>
));
SpeakerWaveFilledSize24Glyph.displayName = 'SpeakerWaveFilledSize24Glyph';
